import { useEffect } from 'react';

const SHOP_ID = 'myShop';

const Merch = () => {
  useEffect(() => {
    if (window.spread_shop_config) {
      return;
    }

    window.spread_shop_config = {
      shopName: 'HelpMeDIY',
      locale: 'us_US',
      prefix: 'https://HelpMeDIY.myspreadshop.com',
      baseId: SHOP_ID,
    };

    const script = document.createElement('script');
    script.src =
      'https://HelpMeDIY.myspreadshop.com/shopfiles/shopclient/shopclient.nocache.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
      delete window.spread_shop_config;
    };
  }, []);

  return (
    <div className="merch">
      <h2>Merch</h2>
      <p>Browse the current Help Me DIY shop items below.</p>
      <div id={SHOP_ID} className="merch-shop">
        <a href="https://HelpMeDIY.myspreadshop.com">HelpMeDIY</a>
      </div>
    </div>
  );
};

export default Merch;
